import{styled as i}from"@lokalise/styled";import{spacing as o}from"../../../utils/theme/index.js";const t=i.div.withConfig({displayName:"PeriodButtons__Container",componentId:"sc-1tdjrye-0"})(["display:grid;gap:",";"],o(2));export{t as Container};
//# sourceMappingURL=styles.js.map
